import { RootState } from '..';

export const selectActiveTab = (state: RootState) => state.products.activeTab;

export const selectActiveParameterSet = (state: RootState) =>
  state.products.activeParameterSet;

export const selectProducts = (state: RootState) => state.products.products;

export const selectFilteredProducts = (state: RootState) =>
  state.products.filteredProducts;

export const selectFilteredProductParameters = (state: RootState) =>
  state.products.filteredProductParameters;

export const selectProductStatuses = (state: RootState) =>
  state.products.productStatuses;

export const selectProductsRequestState = (state: RootState) =>
  state.products.requestState;

export const selectProductsCreated = (state: RootState) =>
  state.products.productsCreated;

export const selectProductsByStatus = (state: RootState) =>
  state.products.productsByStatus;
